import React from "react";
import Icon from "../components/Common/Icon";

export const getOccupancySpan = (spanClass, occupancy) => {
  let icon;
  switch (occupancy) {
    case 1:
    case 2:
      icon = <Icon iconName="occupancy-1"></Icon>;
      break;
    case 3:
      icon = <Icon iconName="occupancy-2"></Icon>;
      break;
    case 4:
      icon = <Icon iconName="occupancy-3"></Icon>;
      break;
    case null:
    case undefined:
      icon = <Icon iconName="occupancy-null"></Icon>;
      break;
    default:
      return "";
  }
  return <span className={spanClass}>{icon}</span>;
};

export const RGBtoHex = (x) =>
  "#" +
  x
    .match(/\d+/g)
    .map((z) => (+z < 16 ? "0" : "") + (+z).toString(16))
    .join("");

export const themeColor = RGBtoHex(
  getComputedStyle(document.getElementById("theme")).backgroundColor
);



// WEBPACK FOOTER //
// ./src/utils/shared.js